export const NpEmailSignupSuccess = () => {
  return (
    <div className="bg-np-green10 flex flex-col gap-4 rounded-2xl px-6 py-8 text-center font-light text-balance xl:gap-6 xl:py-10">
      <p className="text-h3-np">Fast geschafft!</p>
      <p className="text-lg">
        Bestätige deine Anmeldung in der Email, die wir dir gesendet haben. Schau dafür in deinem Email-Postfach nach.
      </p>
    </div>
  )
}
